/**
 *
 *  usePromoCode
 *  Hook
 *
 *  Created by Vladimir Shishlyannikov on 24/04/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React, { useState, useEffect } from "react";

export const usePrice = (price, promoCode, referral, isReferralApplied) => {
  const [_price, setPrice] = useState(price);
  // eslint-disable-next-line
  const [_promoCode, setPromoCode] = useState(promoCode);
  const [_referralCode, setReferralCode] = useState(referral);

  useEffect(() => {
    setPromoCode(promoCode);

    if (promoCode && promoCode.discount && !isReferralApplied) {
      let newPrice =
        promoCode.valueWithDiscount -
        (referral && isReferralApplied ? referral.balance : 0);

      setPrice(newPrice);
    } else if (referral) {
      let newPrice = price - (isReferralApplied ? referral.balance : 0);

      newPrice = Math.max(newPrice, 0);

      setPrice(newPrice);
    } else {
      setPrice(price);
    }
  }, [promoCode, referral, price, isReferralApplied]);

  useEffect(() => {
    setPrice(price);
  }, [price]);

  return [_price];
};

export default usePrice;
